export default "__VITE_ASSET__CJ7Su8Oa__"